import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { compose } from 'redux';

import { reloadJobs } from 'common/actions/jobs';
import AJAX from 'common/AJAX';
import ContentContainer from 'common/containers/ContentContainer';
import { OpenModalContext } from 'common/containers/ModalContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import connect from 'common/core/connect';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import ConfirmModal from 'common/modals/ConfirmModal';
import Tappable from 'common/Tappable';
import withContexts from 'common/util/withContexts';
import TeamStairs from 'img/landing/team-stairs.webp';

import JobSection from './JobSection';

import 'css/components/jobs/_Job.scss';

class Job extends Component {
  static propTypes = {
    job: PropTypes.object,
    location: PropTypes.object,
    openModal: PropTypes.func,
    router: PropTypes.object,
    viewer: PropTypes.object,
  };

  componentDidMount() {
    const { job, router } = this.props;
    if (job) {
      return;
    }

    router.replace('/');
  }

  onDeleteJob = () => {
    const { openModal } = this.props;
    openModal(ConfirmModal, {
      message: 'Are you sure you want to delete this job?',
      onConfirm: () => {
        const { job } = this.props;
        AJAX.post(
          '/api/jobs/delete',
          {
            jobID: job._id,
          },
          (response) => {
            const { reloadJobs, router } = this.props;
            reloadJobs().then(() => {
              router.push('/');
            });
          },
        );
      },
    });
  };

  renderAdminPanel() {
    const { location, viewer } = this.props;
    if (!viewer || !viewer.cannyBae) {
      return null;
    }

    const editLink = location.pathname + '/edit';
    return (
      <div className="adminPanel">
        <Link to={editLink}>Edit Job</Link>
        <Tappable onTap={this.onDeleteJob}>
          <div className="deleteJob">Delete Job</div>
        </Tappable>
      </div>
    );
  }

  renderDepartment() {
    const {
      job: { department },
    } = this.props;
    return <div className="department">{department}</div>;
  }

  renderName() {
    const {
      job: { name },
    } = this.props;
    return <div className="name">{name}</div>;
  }

  renderDetails() {
    const {
      job: { remote },
    } = this.props;
    return <div className="details">{remote ? <div className="detail">Remote</div> : null}</div>;
  }

  renderBlogPostLink() {
    return (
      <a
        href="https://canny.io/blog/work-at-canny/"
        className="blogPostLink"
        rel="noopener"
        target="_blank">
        <LazyLoadedImage alt="Canny team stairs" src={TeamStairs} />
        Read about why Canny is a great place to&nbsp;work
      </a>
    );
  }

  renderApply() {
    const {
      job: { name },
      location: { query },
    } = this.props;
    const source = query.utm_source ? ` | ${query.utm_source}` : '';
    const mailto = `Jobs${source}<jobs@canny.io>?subject=${name}`;
    const details = `If you think you'd be a great fit for this position, [shoot us an email](mailto:${mailto}). Please include your resume and tell us why you want to work at Canny. For brownie points, add your favorite GIF.`;
    return (
      <JobSection
        section={{
          details,
          name: 'Apply',
        }}
      />
    );
  }

  renderSections() {
    const {
      job: { sections },
    } = this.props;
    const items = sections.map((section, i) => {
      return <JobSection section={section} key={i} />;
    });
    return (
      <div className="sections">
        {items}
        {this.renderApply()}
      </div>
    );
  }

  render() {
    const { job } = this.props;
    if (!job) {
      return null;
    }

    return (
      <ContentContainer outerClassName="job">
        <div className="header">
          {this.renderAdminPanel()}
          {this.renderDepartment()}
          {this.renderName()}
          {this.renderDetails()}
          {this.renderBlogPostLink()}
        </div>
        {this.renderSections()}
      </ContentContainer>
    );
  }
}

export default compose(
  connect(null, { reloadJobs }),
  withContexts(
    {
      openModal: OpenModalContext,
      viewer: ViewerContext,
    },
    {
      forwardRef: true,
    },
  ),
)(Job);
